export const Copyright = () => {
  return <div className='text-xs text-neutral-500 text-center'>
    © {new Date().getFullYear()} Senior Choice Financial Inc. All rights reserved.<br />
    <a href='https://www.seniorchoicefinancial.com/privacy-policy/' target='_blank' rel="noreferrer" className='underline'>
      Privacy Policy
    </a>
  </div>;
};